/**
 * CheTuo Web — SaaS admin plan order API.
 */

import { apiClient } from './client';

export interface PlanOrder {
  order: {
    id: string;
    shopId: string;
    subscriptionId: string;
    bizType: string;
    amountCents: number;
    channel: string;
    status: string;
    paidAt: string | null;
    createdAt: string;
  };
  shop: {
    id: string;
    name: string;
  };
  subscription: {
    id: string;
    status: string;
    endAt: string;
  };
  plan: {
    id: string;
    code: string;
    name: string;
  };
}

export interface PlanOrdersResult {
  items: PlanOrder[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ConfirmResult {
  id: string;
  status: string;
  paidAt: string;
  subscription: {
    id: string;
    endAt: string;
    status: string;
  };
}

export function listPlanOrders(params?: {
  status?: string;
  page?: number;
  pageSize?: number;
}): Promise<PlanOrdersResult> {
  const query: string[] = [];
  if (params?.status) query.push(`status=${encodeURIComponent(params.status)}`);
  if (params?.page) query.push(`page=${params.page}`);
  if (params?.pageSize) query.push(`pageSize=${params.pageSize}`);
  const qs = query.length > 0 ? `?${query.join('&')}` : '';
  return apiClient.get<PlanOrdersResult>(`/api/admin/plan-orders${qs}`);
}

export function confirmPlanOrder(orderId: string): Promise<ConfirmResult> {
  return apiClient.post<ConfirmResult>(`/api/admin/plan-orders/${orderId}/confirm`);
}
